export default "__VITE_ASSET__UL2BUk$8__"